/* eslint-disable import/no-unused-modules */
/* eslint-disable prettier/prettier */
export const enum DDKeys { apiKey = '5ff1ad93e9277d0252128082f4e26ae9' }
